import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import compileExpression from 'filtrex'
import styled from 'styled-components'

import Text from '../Text'
import Loading from '../Loading'
import Table from '../Table'

export const GET_PAGES = gql`
  {
    pages {
      id
      price
      template {
        id
        key
      }
      owner {
        id
        firstName
        lastName
      }
    }
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

let operand = '==',
    value   = ''

const columns = [
  {id: 'template', Header: 'Template', accessor: ({template}) => template && template.key},
  {id: 'owner', Header: 'Owner', accessor: ({owner}) => owner && `${owner.firstName} ${owner.lastName}`},
  {
    accessor: 'price', Header: 'Price',
    filterMethod: (filter, row) => {
      try {
        const expression = `${filter.id} ${operand} ${filter.value}`
        const compare = compileExpression(expression)
        return compare(row) === 1
      } catch (e) {
        return false
      }
    },
    Filter: ({filter, onChange}) =>
      <Wrapper>
        <select
          onChange={event => {
            operand = event.target.value
            onChange(value)
          }}
          style={{width: '50%', height: 28}}>
          <option value='=='>Equals</option>
          <option value='>'>Greater Than</option>
          <option value='<'>Less Than</option>
        </select>
        <input
          onChange={event => {
            value = event.target.value
            onChange(value)
          }}
          type='number'
          style={{width: '50%'}}
          value={filter ? filter.value : ''}
        />
      </Wrapper>
  }
]

const List = ({onRowClick, filterable}) =>
  <Query query={GET_PAGES} fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (error) return <Text error>{error.message}</Text>

      return (
        <React.Fragment>
          {loading && <Loading />}
          <Table
            filterable={filterable}
            noDataText={!loading && 'No pages found!'}
            loading={loading}
            data={data.pages}
            columns={columns}
            onRowClick={onRowClick}
          />
        </React.Fragment>
      )
    }}
  </Query>

export default List


// WEBPACK FOOTER //
// ./src/components/Pages/List.js